import React from "react";
import { SxProps } from "@mui/material";
import { DefaultOnOff } from "../../Form/Utilities/DefaultOnOff";
import { ObserveState } from "../StateManagement/ObserveState";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { UIToggleButtons } from "../BuildlingBlocks/UIToggleButtons";

export interface PropertyEditorToggleButtonsInterface {
    editObject: object;
    propertyName: string;
    label?: string;
    hint?: string;
    options?: string[];
    name?: string;
    onChange?: () => void;
    sx?: SxProps;
    error?: string;
    ignoreDesignerValidation?: boolean;
}

export const PropertyEditorToggleButtons: React.FC<PropertyEditorToggleButtonsInterface> = (
    props: PropertyEditorToggleButtonsInterface,
) => {
    const onChange = (newValue: string | undefined) => {
        Reflect.set(props.editObject, props.propertyName, newValue);
        StateManager.propertyChanged(props.editObject, props.propertyName);
        if (props.onChange) props.onChange();
    };

    const value = Reflect.get(props.editObject, props.propertyName);

    const options = props.options || [DefaultOnOff.DEFAULT, DefaultOnOff.Off, DefaultOnOff.On];

    return (
        <ObserveState
            listenTo={props.editObject}
            properties={[props.propertyName]}
            control={() => {
                return (
                    <UIToggleButtons
                        fullWidth={true}
                        label={props.label}
                        hint={props.hint}
                        error={props.error}
                        options={options}
                        value={value}
                        onChange={onChange}
                    />
                );
            }}
        />
    );
};
